<template>
    <div>
        <div v-for="order in orders" :key="order.id">
            <order :order-id="order.id"></order>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'all-orders',
        data() {
            return {
            }
        },
        computed: Object.assign({}, mapGetters(['orders']))
    };
</script>



// WEBPACK FOOTER //
// AllOrders.vue?cd7df3ee